import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import AudioMemory from './components/AudioMemory';
import TextMemory from './components/TextMemory';
import MediaUpload from './components/MediaUpload';
import Location from './components/Location';
import SuccessModal from './components/SuccessModal';

const pageVariants = {
  initial: { opacity: 0, y: 20 },
  animate: { opacity: 1, y: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  exit: { opacity: 0, y: -20, transition: { duration: 0.3 } }
};

function App() {
  const [activeSection, setActiveSection] = useState('home');
  const [successMessage, setSuccessMessage] = useState('');

  const showSuccess = (msg) => {
    setSuccessMessage(msg);
    setTimeout(() => setSuccessMessage(''), 3000);
  };

  const renderSection = () => {
    switch (activeSection) {
      case 'audio':
        return <AudioMemory onSuccess={showSuccess} onBack={() => setActiveSection('home')} />;
      case 'text':
        return <TextMemory onSuccess={showSuccess} onBack={() => setActiveSection('home')} />;
      case 'media':
        return <MediaUpload onSuccess={showSuccess} onBack={() => setActiveSection('home')} />;
      case 'location':
        return <Location onBack={() => setActiveSection('home')} />;
      default:
        return <Hero onNavigate={setActiveSection} />;
    }
  };

  return (
    <div className="min-h-screen min-h-[100dvh] bg-ivory-50 font-montserrat relative overflow-hidden">
      {/* Dekoratif arka plan deseni */}
      <div className="fixed inset-0 pointer-events-none z-0">
        <div className="absolute top-0 right-0 w-64 h-64 bg-sage-100 rounded-full opacity-30 -translate-y-1/2 translate-x-1/3" />
        <div className="absolute bottom-0 left-0 w-80 h-80 bg-sage-100 rounded-full opacity-20 translate-y-1/2 -translate-x-1/3" />
        <div className="absolute top-1/2 right-0 w-40 h-40 bg-gold-300 rounded-full opacity-10 translate-x-1/2" />
      </div>

      {/* Ana içerik */}
      <div className="relative z-10">
        <AnimatePresence mode="wait">
          <motion.div
            key={activeSection}
            variants={pageVariants}
            initial="initial"
            animate="animate"
            exit="exit"
            className="pb-24"
          >
            {renderSection()}
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Alt navigasyon */}
      {activeSection !== 'home' && (
        <Navigation active={activeSection} onNavigate={setActiveSection} />
      )}

      {/* Başarı bildirimi */}
      <AnimatePresence>
        {successMessage && <SuccessModal message={successMessage} />}
      </AnimatePresence>
    </div>
  );
}

export default App;
